import * as React from "react";
import { Button, Collapse } from "antd";
import { RefreshCw } from "react-feather";
import { CHART_MIN_WIDTH, CHART_MAX_WIDTH } from "./utils";

interface ChartGroupProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

const GAP_SIZE = 16;

const chartGridStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: `repeat(auto-fill, minmax(${CHART_MIN_WIDTH}px, ${CHART_MAX_WIDTH}px))`,
  gap: GAP_SIZE,
};

export const ChartGroup: React.FC<ChartGroupProps> = ({ title, children, defaultOpen = true }) => {
  const [refreshKey, setRefreshKey] = React.useState(0);
  const [activeKey, setActiveKey] = React.useState<string[]>(defaultOpen ? ["1"] : []);

  const isExpanded = activeKey.includes("1");

  const handleRefresh = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent collapse toggle
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Collapse
      activeKey={activeKey}
      onChange={(keys) => setActiveKey(keys as string[])}
      style={{ borderColor: "var(--color-border)" }}
      items={[
        {
          key: "1",
          label: (
            <div className="flex items-center gap-3">
              <span className="text-lg font-medium">{title}</span>
              <Button
                type="text"
                size="small"
                icon={<RefreshCw size={14} />}
                onClick={handleRefresh}
                title="Refresh charts"
              />
            </div>
          ),
          children: isExpanded ? (
            <div key={refreshKey} style={chartGridStyle}>
              {children}
            </div>
          ) : null,
          style: { borderColor: "var(--color-border)" },
        },
      ]}
    />
  );
};
